import request from '@/utilsCloud/request'
import port from './port'

// 获取所有岗位数据
export function getUnderlineCourseListFromEnterprise(query) {
  return request({
    url: port.course + '/enterprise/underline/getUnderlineCourseListFromEnterprise',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/apiCloud/offlineCourseList.js